// config.castellarnau.js
/*
  CICLES (Mireia Guixà - Mercè Carceles)

  NESE
  NESEObservacions

  demanaConvalidacions
  demanaBeca

  authSortides

    "authIntranet": authIntranet,
    "authPublicacions": authPublicacions,
    "authMaterial": authMaterial,
    "authInternet": authInternet,
    "authGDPR": authGDPR,
    "authSortides": authSortides

*/

const config = {
  cid: 'a8024893',

  // llistat dels camps d'autorització del pas "Protecció de dades" d'aquest centre
  // (veure src/components/enrolmentform/authorizations/castellarnau/)
  autoritzacions: [
    'authGDPR', 'authInternet', 'authIntranet', 'authMaterial', 'authPublicacions', 'authSortides',
  ],

  phone: "93 726 94 22",
  email: "secretaria@institutcastellarnau.cat",

  headerLogo:  'img/logo_bn_castellarnau.png',
  headerTitle:  'Institut Castellarnau',
  headerURL: 'https://matricula.institutcastellarnau.cat/',

  enrollmentPostURL: '/post/',
  apiURL: '/api/',

  popupInicial: true,

  /* valor per defecte (mandatori); es pot sobreescriure per curs concret amb
     curs.adjuntarArxiusNoObligatori a les dades de families (chkiddoc + cursObligatori);
     aquest valor només s'aplica a la matrícula lliure, sense curs obligatori */
  adjuntarArxiusNoObligatori: false,

  validaIDdocuments: true,
  tipusDocTSI: false,

  fotoCarnet: true,    
  validaIAfotoCarnetFile: true,
  validaIAiddocumentFrontFile: false,

  adrecaDesglossada: true,

  telefonObligatori: true,
  carnetFamiliaNombrosa: false,
  
  contacteEmergenciaObligatori: false,

  adjuntMedic: false,
  adjuntMedicObligatori: false,

  datesNoBloquejenInscripcio: false,

  noPreguntarSiEsNouAlumne: false,

  proporcionarPreinscripcioNous: true,
  proporcionarTitolPreinscripcioNous: true,

  notesAcces: false,

  mostraTorns: true,

  demanaConvalidacions: true,
  demanaConvalidacionsText: "Podeu utilitzar el camp d'observacions per fer qualsevol indicació al respecte:",
  demanaConvalidacionsFile: false,
  demanaBeca: true,

  logo: 'img/logo_castellarnau.jpg',
  titol: 'IES Castellarnau',

  favicon: '/img/favicon-castellarnau.ico',
  faviconGestio: '/gestio/img/favicon-castellarnau.ico',

  assignatures: 'assignatures/assignatures.castellarnau.json',
  families: 'families/families.castellarnau.json',
  dadesbancaries: 'dadesbancaries/dadesbancaries.castellarnau.json',
  calculquota: 'quotes.castellarnau.json',   

  treballantFile: false, 
  necessitatsEducativesEspecials: false,
  necessitatsEducativesEspecialsDesplegable: [
                                              { id: "transtorns", value: "trastorns que condicionen l'aprenentatge"},
                                              { id: "autista", value: "trastorns d'aspectre autista"},
                                              { id: "nouvingut", value: "alumnat nouvingut (últims dos anys)"},
                                              { id: "altres", value: "altres" }
                                              ],

  repetidor: true,
  repetidorsNoPodenAgafarAssignaturesDe2n: true,

  textDadesMediquesAlgunSi: "S’haurà de portar una fotocòpia de la patologia esmentada mitjançant un informe mèdic i donar-li al tutor/a de grup el dia de la presentació.",

  textBotoMatricular: "MATRÍCULA",

  textAlumneNouAlCentre: "Ets alumne/a nou/nova al nostre centre?",
  textAlumneNouAlCentreSub: null,

  urlTPV: "https://matricula.institutcastellarnau.cat/tpv/",
  pagamentTPV: true,
  pagamentTransferencia: false,


  dosTerminisDefault: false, // per defecte el dos terminis està activat
  dosTerminisAmagaBoto: false, // no cal ni mostrar botó

  /* el pagament en dos terminis només està habilitat durant el primer periòde de matriculacions */
  dosTerminisEnabled: (new Date().getMonth() >= 4 && new Date().getMonth() <= 7),
  /* si es fals mostrem unes altres condicions de pagament */
  dosTerminisEnabledFalseCondicio: 0,

  sexeNoBinari: false,

  pattern_batx_nocturn: /^BATXLOE\d{5}N[A-Z]{1,2}$/,
  pattern_1r_batx: /^BATXLOE\d{4}1[^N][A-Z]{1,2}$/,
  pattern_2n_batx: /^BATXLOE\d{4}2[^N][A-Z]{1,2}$/,

  su: ['WyIxMTExMTEx', 'MUgiLCIyMjIyMjIyM', 'koiLCI0NTQ5MjQwNVMiXQ=='],
};

export default config;
